<div class="container-fluid">
  <div class="row top_search_block">
    <div class="col-md-4">
      <div class="top_header_search">
        <form [formGroup]="form">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              formControlName="search"
            />
            <div class="input-group-addon">
              <span class="input-group-text" id="basic-addon1"
                ><i class="fa fa-search"></i
              ></span>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="col-md-8">
      <div class="row">
        <div class="offset-md-2 col-md-6">
          <h1 class="heading text-center">Manage Companies</h1>
        </div>
      </div>
      <div class="row">
        <div class="offset-md-6 col-md-6">
          <button
            type="button"
            class="btn btn-square pull-right"
            (click)="onAddCompany()"
          >
            + Add Company
          </button>
          <button
            type="button"
            class="btn btn-square pull-right"
            [routerLink]="['/dashboard']"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <ps-ui-paginated-list
        [length]="total"
        [limit]="pagination.limit"
        (pageChange)="onPageChange($event)"
      >
        <ps-ui-paginated-list-item empty>
          <p description>No Users Available</p>
        </ps-ui-paginated-list-item>
        <ng-container *ngIf="companies$ | async as companies">
          <div class="users-list" *ngFor="let company of companies">
            <ps-ui-paginated-list-item
              [active]="selected?.id === company.id || false"
              (tap)="selected = company"
            >
              <div class="title" title>
                <p>
                  {{ company.name }}
                </p>
              </div>
              <br />
            </ps-ui-paginated-list-item>
          </div>
        </ng-container>
      </ps-ui-paginated-list>
    </div>
    <div class="col-md-8">
      <ps-manage-companies-form
        *ngIf="selected; else noForm"
        [company]="selected"
        (added)="getCompanies()"
        (deleted)="onCompanyDeleted()"
      ></ps-manage-companies-form>
      <ng-template #noForm>
        <div class="selected-company">
          <p>
            Choose an existing company or<br />
            click “Add Company” to get started
          </p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
